module.exports = __webpack_public_path__ + "static/media/sessionHomeBackground.6382fc11.png";